module.exports = __webpack_public_path__ + "assets/img/meeting-image11.0feacd21.png";